import * as React from 'react';
import {Subject}  from 'rxjs';

import {PLAYER_SETTINGS_CLOSE} from '../../../../Shared/Constants/TestIds';
import UiEventType             from '../../../../Shared/Constants/UiEventType';
import IUiEventsStreamPayload  from '../../../../Shared/Interfaces/IUiEventsStreamPayload';
import renderTestId            from '../../../Util/renderTestId';

import IconClose   from './Assets/IconClose';
import * as styles from './container.css';

interface ISettingsCloseProps {
    uiEvents$: Subject<IUiEventsStreamPayload>;
}

class SettingsClose extends React.Component<ISettingsCloseProps> {
    constructor(props) {
        super(props);

        this.handleClick = this.handleClick.bind(this);
    }

    public render(): JSX.Element {
        return (
            <div
                className={styles.close}
                onClick={this.handleClick}
                data-test-id={renderTestId(PLAYER_SETTINGS_CLOSE)}>
                <IconClose />
            </div>
        );
    }

    private handleClick(): void {
        this.props.uiEvents$.next({
            type: UiEventType.SETTINGS_CLOSE_TAP
        });
    }
}

export default SettingsClose;